import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "table-header"
  }, [_c("div", {
    staticClass: "table-header-filters"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.statusOptions,
      "item-value": "id",
      "item-text": "name",
      label: "Filter by status",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item,
          on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VListItem, _vm._g(_vm._b({}, "v-list-item", attrs, false), on), [_c(VListItemAction, [_c(VCheckbox, {
          attrs: {
            "input-value": _vm.selected.includes(item.id),
            "disable-ripple": ""
          }
        })], 1), _c(VListItemIcon, [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: "fill-".concat(_vm.colorFor(item.id)),
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })])]), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))])], 1)], 1)];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item,
          index = _ref2.index,
          select = _ref2.select,
          selected = _ref2.selected;
        return [_c(VChip, {
          key: index,
          attrs: {
            small: "",
            close: "",
            dark: ""
          },
          on: {
            click: function click($event) {
              return select(item);
            },
            "click:close": function clickClose($event) {
              return _vm.removeSelection(item);
            }
          }
        }, [_c("svg", {
          staticClass: "icon icon-xxs dot mr-2",
          class: "fill-".concat(_vm.colorFor(item.id)),
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s(item.name) + " ")])];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1), _c("div", {
    staticClass: "table-header-actions"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    on: {
      click: function click($event) {
        return _vm.$emit("export-errors");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file-export mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Export errors ")], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };